export enum Funnel {
  FINANCING_FIRST = 'FINANCING_FIRST',
  AUTO_FIRST = 'AUTO_FIRST',
  HUBS = 'HUBS',
  MINERVA = 'MINERVA',
  MY_ACCOUNT = 'MY_ACCOUNT',
  TURNOMETER = 'TURNOMETER',
  SECOND_HOLDER = 'SECOND_HOLDER',
  COMPLEMENTARY_DATA = 'COMPLEMENTARY_DATA',
}
